import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52db104d"
import script from "./description.js?vue&type=script&lang=js&external"
export * from "./description.js?vue&type=script&lang=js&external"
import style0 from "./description.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports